// Copyright (c) 2017 Deere & Company

import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import t from 'tcomb';

const SelectedDealers = t.list(Dealer, 'SelectedDealers');

export const getDefaultState = () => new SelectedDealers([]);

export default SelectedDealers;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state/selected-dealers.js